/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOverdueEvent.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/overdue-event";

export class AutogenModelOverdueEvent<RowType extends ModelRow> extends Endpoint<RowType, RowOverdueEventFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOverdueEvent extends ModelRow<RowOverdueEventFields> {
	constructor(values?: Partial<RowOverdueEventFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOverdueEventFields {
	alert_descr: string;
	alert_type: string;
	company_id: string;
	event_table_key: string;
	event_table_name: string;
	id: string;
	is_active: string;
	movement_id: string;
	next_alert_date: Date;
	overdue_date: Date;
	rapid_alert_def_id: string;
	table_change_event: string;
}

